/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_AccessUser_Array_ } from '../models/ControllerResponse_AccessUser_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_RentSourceSubscriptionAttributes_ } from '../models/ControllerResponse_RentSourceSubscriptionAttributes_';
import type { ControllerResponse_RentSourceSubscriptionAttributes_Array_ } from '../models/ControllerResponse_RentSourceSubscriptionAttributes_Array_';
import type { ControllerResponse_RentSourceSubscriptionAttributes_or_null_ } from '../models/ControllerResponse_RentSourceSubscriptionAttributes_or_null_';
import type { Record_string_string_or_number_or_boolean_ } from '../models/Record_string_string_or_number_or_boolean_';
import type { RentSourceSubscriptionAttributes } from '../models/RentSourceSubscriptionAttributes';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PropertyReportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List property report subscriptions that belong to the current user, or all reports for the organization.
     * @param admin Set this to true to get all reports that belong to the organization, and not just the ones for the current user
     * @returns ControllerResponse_RentSourceSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(
        admin?: boolean,
    ): CancelablePromise<ControllerResponse_RentSourceSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/list',
            query: {
                'admin': admin,
            },
        });
    }
    /**
     * Update the metadata of a property report.
     * @param reportId The ID of the property report to update
     * @param requestBody The metadata to update. Must be a flat object with string, number or boolean values.
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public updateMetadata(
        reportId: number,
        requestBody: Record_string_string_or_number_or_boolean_,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/property_report/{reportID}/metadata',
            path: {
                'reportID': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_RentSourceSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: RentSourceSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_RentSourceSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property_report',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a property report by ID or public ID. Only one of id or public_id should be provided.
     * @param id The ID of the property report to get
     * @param publicId The public ID of the property report to get
     * @returns ControllerResponse_RentSourceSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public getReport(
        id?: number,
        publicId?: string,
    ): CancelablePromise<ControllerResponse_RentSourceSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report',
            query: {
                'id': id,
                'public_id': publicId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_RentSourceSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public update(
        requestBody: RentSourceSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_RentSourceSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/property_report',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public delete(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/property_report',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public getAccess(
        reportId: number,
    ): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
        });
    }
    /**
     * @param reportId
     * @param notify
     * @param requestBody
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public createAccess(
        reportId: number,
        notify: boolean,
        requestBody: Array<{
            email: string;
            user_id: string | null;
        }>,
    ): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
            query: {
                'notify': notify,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param reportId
     * @param id
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public deleteAccess(
        reportId: number,
        id: string,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public sendEmail(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/send_email',
            query: {
                'id': id,
            },
        });
    }
}
